// this is an autogenerated file from DesignSystem/CheckOutAction/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_CheckOutAction($id: uuid!) {
  vaxiom_appointment_booking_check_out(id: $id) {
    id
    appointment_booking {
      id
      _id
      state
      start_time
      end_time
      local_start_date
      local_start_time
      provider_id
      assistant_id
      chair_id
    }
  }
}

`